import DocumentMeta from "react-document-meta";
import bg3Img from "../../../../assets/images/bg3.jpg";
import lineImg from "../../../../assets/images/line.png";
import cohortProgram from "../../../../assets/images/cohort-program.png";
import requestMentor from "../../../../assets/images/request-mentor.png";
import parse from "html-react-parser";
import "../HowItWorks/styles.scss";
import { useHistory } from "react-router-dom";
import "./style.scss";
import { useTranslation } from 'react-i18next';
const FindHomeMentor = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  //
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  return (
    <DocumentMeta {...meta}>
      <div className="how-it-work-bg">
        <div class="w-100 pt-50 pb-50 position-relative text-center">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0 homepageFirstHeader">
                {t('GET_A_MENTOR')}
                  {/* Get a Mentor */}
                  </h2>
              </div>
              <div class="col-md-12 col-sm-12 col-lg-12 wow fadeInDown kldhdfk">
                <div
                  class="get-a-mentor button-about kldhdfk newuserTooltip"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/get-a-mentor");
                  }}
                >
                  <p style={{ cursor: "pointer" }}>
                    <a
                      style={{ fontSize: "20px" }}
                      className="interested-link homepageFirstDescription"
                      href="/get-a-mentor"
                    >
                      {t('Leverage_our_AI_platform_to_get_matched_with_expert')}
                      {/* Leverage our AI platform to get matched with expert
                      mentors relevant to your unique needs.{" "} */}
                    </a>
                    <span className="tooltiptext  tooltip-bottom" style={{padding:"2px 12px",left:"46%",top:"57px",width:"193px"}}>
                          Click to View Get A Mentor
                        </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="row" style={{ paddingTop: "20px" }}>
              <div class="col-md-6 col-sm-6 col-lg-6 wow ">
                <div class="row">
                  <div class="col-md-4 col-sm-4 col-lg-4 wow slideInLeft">
                    <img src={props.data && parse(props.data[0].Image)} />
                  </div>
                  <div class="col-md-8 col-sm-8 col-lg-8 wow slideInLeft">
                    <div class="info leverage homepageFirstDescription" style={{ fontSize: "20px" }}>
                      <h4 style={{ fontSize: "20px" }} className="homepageFirstDescription">
                        {/* REQUEST A MENTOR MATCH */}
                        {props.data && parse(props.data[0].Heading)}
                      </h4>

                      {/* <p>Submit an application to request a mentor match</p> */}
                      {props.data && parse(props.data[0].Text)}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-sm-6 col-lg-6 wow">
                <div class="row">
                  <div class="col-md-4 col-sm-4 col-lg-4 wow slideInRight">
                    <img src={props.data && parse(props.data[1].Image)} />
                  </div>
                  <div class="col-md-8 col-sm-8 col-lg-8 wow slideInRight">
                    <div class="info leverage homepageFirstDescription" style={{ fontSize: "20px" }}>
                      <h4 className="homepageFirstDescription" style={{ fontSize: "20px" }}>
                        {/* APPLY FOR A COHORT PROGRAM */}
                        {props.data && parse(props.data[1].Heading)}
                      </h4>

                      {/* <p>Submit an application for a curated cohort program</p> */}
                      {props.data && parse(props.data[1].Text)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DocumentMeta>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default FindHomeMentor;
